import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=6fa8e226&"
import script from "./Summary.vue?vue&type=script&lang=ts&"
export * from "./Summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QBtn} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QBtn}, component.options.components || {})
